module.exports = __webpack_public_path__ + "img/goldrush.93a14565.svg";